// www/src/components/Loader.tsx
const Loader: React.FC = () => (
        <div className="h-full flex items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
    )
export default Loader;